import React from 'react';
import { translate } from 'utlis/translations/i18n';

class InterludePagination extends React.Component {
    render() {
        const { sessionInstance, session, className = '' } = this.props;
        const { currentInterlude } = sessionInstance;
        const { data } = session;
        const { interludes = [] } = data;

        return (
            <div className={"sequence-pagination-wrapper " + className}>
                <div className="pagination">
                    <span className="muted">{translate('introduction')}</span> {currentInterlude + 1} <span className="muted">{translate('of')}</span> {interludes.length}
                </div>
            </div>
        );
    }
}
export default InterludePagination;